import React from 'react';
import { getLoggedUser } from '../../../../state/user';
import i18n from '../../../../i18n';
import { getOrganizationList } from '../../../../models/organization';
import { HomeBanner } from '../../../home/homeBanner';
import { SideBar } from '../../components/Sidebar/Sidebar';
import FilterSection from '../../../common/Filter';
import Dropdown from '../../../common/DropDown';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { getDeliveryGroups } from './services/auctionApprovalServices';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { apiUrl } from '../../../../constants/global';
import { CheckCircle, Clock, FileCheck, List, TrendingDown, TrendingUp } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { AuctionAddFundModal } from './components/AuctionAddFundModal';
import StatusCards from '../../../common/StatusCard';

const user = getLoggedUser();
const roleAllowedStatuses = {
  PM: ['pending', 'approved', 'fundAdded', 'financeSettled', 'all'],
  F: ['approved', 'fundAdded', 'fundDeduct', 'financeSettled', 'all'],
};
const rawStatusData = [
  { key: 'pending', label: 'Pending', count: 0, icon: Clock },
  { key: 'approved', label: 'Approved', count: 0, icon: CheckCircle },
  { key: 'fundAdded', label: 'Fund Added', count: 0, icon: TrendingUp },
  { key: 'fundDeduct', label: 'Fund Deduct', count: 0, icon: TrendingDown },
  { key: 'financeSettled', label: 'Completed', count: 0, icon: FileCheck },
  { key: 'all', label: 'All', count: 0, icon: List },
];

const allowedKeys = user ? roleAllowedStatuses[user.role] || [] : [];
const initialStatusData = rawStatusData.filter((status) => allowedKeys.includes(status.key));

export class AuctionApprovalList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        client: '',
        startDate: null,
        endDate: null,
      },
      status: rawStatusData[0],
      input: {},
      clients: [],
      deliveryGroups: [],
      statusData: initialStatusData,
      isLoading: false,
      showAddFund: false,
      limit: 15,
      page: 1,
      columns: [
        {
          id: 1,
          name: 'Sl No',
          width: '90px',
          sortable: true,
          wrap: true,
          cell: (row, i) => i + 1,
        },
        {
          id: 2,
          name: 'ID',
          width: '80px',
          sortable: true,
          wrap: true,
          cell: (row) => row.id,
        },
        {
          id: 3,
          minWidth: '130px',
          name: i18n.t('project_code'),
          cell: (row) => <span className="highlight-project-code">{row.project_code}</span>,
        },
        {
          id: 12,
          name: i18n.t('project_duration'),
          minWidth: '140px',
          cell: (row) => {
            if (!row.actual_start_date || !row.expected_end_date) return '-';

            const start = new Date(row.actual_start_date);
            const end = new Date(row.expected_end_date);

            const diffTime = end - start; // in milliseconds
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert to days

            return `${diffDays} days`;
          },
          wrap: true,
          center: true,
        },
        {
          id: 4,
          minWidth: '130px',
          name: i18n.t('group_name'),
          cell: (row) => row.group_name,
        },
        {
          id: 5,
          name: i18n.t('client'),
          cell: (row) => row.organization_name,
          wrap: true,
        },
        {
          id: 6,
          name: i18n.t('auctions'),
          width: '90px',
          cell: (row) => row.auctions_count,
          wrap: true,
          center: true,
        },
        {
          id: 7,
          name: i18n.t('start_date'),
          cell: (row) => row.start_date,
          wrap: true,
        },
        {
          id: 8,
          name: i18n.t('end_date'),
          cell: (row) => row.end_date,
          wrap: true,
        },
        // {
        //   id: 9,
        //   minWidth: '80px',
        //   name: i18n.t('estimated days'),
        //   cell: (row) => 1,
        //   wrap: true,
        //   center: true,
        // },
        {
          id: 10,
          minWidth: '130px',
          name: i18n.t('total_amount'),
          cell: (row) => row.total_amount.toFixed(3),
          wrap: true,
          right: true,
        },
        {
          id: 11,
          name: i18n.t('action'),
          wrap: true,
          minWidth: '160px',
          cell: (row) => (
            <div className="action-buttons">
              {getActionButtons(row, this.state.status, user, this)}
            </div>
          ),
        },
      ],
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      client: params.get('client') || '',
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
    };
    const status = params.get('status') || 'pending';
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, status, page, limit }, () => {
      this.getAllOrganization?.();
      this.getDeliveryGroups();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getDeliveryGroups() {
    this.setState({ isLoading: true });
    let { limit, page, status } = this.state;
    let { client, startDate, endDate } = this.state.search;
    const queryStatus = status === 'all' ? null : status;
    const q = {
      page: page,
      limit: limit,
    };
    if (queryStatus) q.status = queryStatus;
    if (client) q.client = client;
    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getDeliveryGroups(q);
    if (response.success) {
      let deliveryGroups = response.data;
      let {
        total,
        pendingCount,
        approvedCount,
        fundaddedCount,
        fundDeductedCount,
        completedCount,
        allCount,
      } = response.meta;
      const rawStatusData = [
        { key: 'pending', label: 'Pending', count: pendingCount, icon: Clock },
        { key: 'approved', label: 'Approved', count: approvedCount, icon: CheckCircle },
        { key: 'fundAdded', label: 'Fund Added', count: fundaddedCount, icon: TrendingUp },
        { key: 'fundDeduct', label: 'Fund Deduct', count: fundDeductedCount, icon: TrendingDown },
        { key: 'financeSettled', label: 'Completed', count: completedCount, icon: FileCheck },
        { key: 'all', label: 'All', count: allCount, icon: List },
      ];

      const allowedKeys = roleAllowedStatuses[user.role] || [];
      const filteredStatusData = rawStatusData.filter((status) => allowedKeys.includes(status.key));

      let activeStatus = this.state.status;
      if (!allowedKeys.includes(activeStatus)) {
        activeStatus = filteredStatusData[0]?.key;
      }

      this.setState({
        deliveryGroups,
        total,
        statusData: filteredStatusData,
        status: activeStatus,
        isLoading: false,
      });
    }
    this.setState({ isLoading: false });
  }
  async getAllOrganization() {
    const response = await getOrganizationList();
    let clients = response.data;
    this.setState({ clients });
  }

  handleTabChange = (key) => {
    this.setState({ status: key }, () => {
      this.getDeliveryGroups();
    });
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      const updatedSearch = { ...prevState.search, [name]: value };
      return { search: updatedSearch };
    });
  };

  handleSearch = () => {
    this.getDeliveryGroups();
  };

  handleClear = () => {
    const defaultSearch = {
      client: '',
      startDate: null,
      endDate: null,
      status: this.state.status,
    };

    this.setState({ search: defaultSearch, page: 1 }, () => {
      this.updateUrlQuery({ page: 1, limit: this.state.limit });
      this.getDeliveryGroups();
    });
  };

  onChangePage = (page) => {
    console.log('page', page);

    this.setState({ page: page }, () => {
      this.getDeliveryGroups();
    });
  };

  onChangeRowsPerPage = (limit) => {
    console.log('row', limit);
    this.setState({ limit: limit, page: 1 }, () => {
      this.getDeliveryGroups();
    });
  };
  onAddFund = async (group) => {
    this.setState({ showAddFund: true, selectedGroup: group });
  };

  render() {
    const { clients, deliveryGroups, showAddFund, selectedGroup } = this.state;

    return (
      <React.Fragment>
        <HomeBanner />
        <section className="mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <h3 className="card-title">
                      {user.role === 'F' ? i18n.t('client_payment') : i18n.t('auction_approval')}
                    </h3>
                    <StatusCards
                      tabs={this.state.statusData}
                      activeTab={this.state.status}
                      onTabChange={this.handleTabChange}
                      loading={this.state.isLoading}
                    />
                    <FilterSection
                      loading={this.state.isLoading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Start Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="startDate"
                          type="date"
                          name="startDate"
                          value={this.state.search.startDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder=" " // Important: single space for floating effect
                        />
                        <label htmlFor="startDate" className="floating-label">
                          {i18n.t('start_date')}
                        </label>
                      </div>

                      {/* End Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="endDate"
                          type="date"
                          name="endDate"
                          value={this.state.search.endDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder={i18n.t('end_date')}
                        />
                        <label htmlFor="endDate" className="floating-label">
                          {i18n.t('end_date')}
                        </label>
                      </div>
                      {/* Client Dropdown */}
                      <Dropdown
                        name="client"
                        value={this.state.search.client}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('client_name')}
                        empty={i18n.t('select_client')}
                        options={clients.map((c) => ({ value: c.id, label: c.organization_name }))}
                      />
                    </FilterSection>
                    <div className="Data-Listing">
                      {this.state.isLoading ? (
                        <TableSkeleton columns={10} rows={10} />
                      ) : this.state.deliveryGroups.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.state.columns}
                          data={deliveryGroups}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: 'Groups per page:',
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message="No Auctions Available"
                          actionText="Refresh"
                          onAction={this.getDeliveryGroups.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <AuctionAddFundModal
          show={showAddFund}
          onClose={() => {
            this.getDeliveryGroups();
            this.setState({ showAddFund: false, selectedGroup: null });
          }}
          group={selectedGroup}
        />
      </React.Fragment>
    );
  }
}

const getActionButtons = (row, status, user, ctx) => {
  const buttons = [];

  const isPM = user.role === 'PM';
  const isFinance = user.role === 'F';
  const hasAuctions = row.auctions.length > 0;

  const detailPath = `/auction_approval/${row.id}?status=${ctx.state.status}`;

  // PENDING
  if (status === 'pending' && isPM) {
    buttons.push(<ActionButton key="process" label="process" to={detailPath} />);
  }

  // APPROVED
  if (status === 'approved') {
    if (isPM) {
      // buttons.push(
      //   <ActionButton
      //     key="add_fund"
      //     label="add_fund"
      //     icon={<Plus />}
      //     variant="warning"
      //     onClick={() => ctx.onAddFund(row)}
      //   />
      // );
      buttons.push(<ActionButton key="view" label="view" to={detailPath} />);
    } else if (isFinance) {
      buttons.push(<ActionButton key="view" label="view" to={detailPath} />);
    }
  }

  // FUND ADDED
  if (status === 'fundAdded') {
    if (isFinance) {
      buttons.push(<ActionButton key="process" label="process" to={detailPath} />);
    }
    if (isPM) {
      buttons.push(<ActionButton key="view" label="view" to={detailPath} />);
    }
  }
  // FUND DEDUCT
  if (status === 'fundDeduct') {
    if (isFinance) {
      buttons.push(<ActionButton key="process" label="process" to={detailPath} />);
    }
  }
  // COMPLETED
  if (status === 'financeSettled' && hasAuctions) {
    buttons.push(<ActionButton key="view" label="view" to={detailPath} />);

    // Invoice button
    buttons.push(
      <a
        key="invoice"
        className="btn-new btn-action"
        style={{ whiteSpace: 'nowrap', cursor: 'pointer', marginRight: '4px' }}
        href={`${apiUrl}auction_approval/invoice?group=${row.id}`}
        target="_blank"
        rel="noreferrer"
      >
        {i18n.t('invoice')}
      </a>
    );
  }

  return buttons;
};

const ActionButton = ({ label, icon, to, variant = 'info', onClick }) => {
  if (to) {
    return (
      <NavLink
        to={to}
        className={`btn-new btn-action`}
        style={{ whiteSpace: 'nowrap', cursor: 'pointer', marginRight: '4px' }}
      >
        {icon} {i18n.t(label)}
      </NavLink>
    );
  }

  return (
    <button
      className={`btn-new btn-action`}
      style={{ whiteSpace: 'nowrap', cursor: 'pointer', marginRight: '4px' }}
      onClick={onClick}
    >
      {icon} {i18n.t(label)}
    </button>
  );
};
